import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { Multilingual } from 'src/app/services/multilingual';
import { ProductivityService } from 'src/app/services/productivity-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import * as Highcharts from 'highcharts';
import { Chart } from 'angular-highcharts';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  // @ViewChild('agGrid') agGrid!: AgGridAngular;
  AdminDashboardForm!: FormGroup;
  breadcrumList: any;
  IsAccess: any;
  IsWrite: any;
  GroupList!: any[];
  PlantList1!: any[];
  DashboardData!: any;
  DetailsData!:any;
  CONNECTEDMACHINE:number = 0
  NONCONNECTEDMACHINE:number=0
  NOOFMODULEINPLANT:number=0
  NOOFUSERLOGINLAST24:number=0
  NOOFUSERSINPLANT:number=0
  NOTOFLINEINPLANT:number=0
  TOTALNOOFMACHINE:number=0
  OTHER : number=0
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  filteredGroups: any;
  filteredPlants: any;
  lang: any;
  chartLoginUserstrends!: Chart;
  options: any;
  format = 'YYYY-MM-DD HH:mm:ss';
  type!:any;
  @ViewChild('displayDetailsModal') private displayDetailsModal!: TemplateRef<any>;
  // iconUrl
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';
  menuBlueIconUrl = 'assets/images/menu-bottom-blue-icon.png';
  rowData!: any[];
  columnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;
  gridOptions: any = {
    defaultColDef: {
      flex: 1,
      minWidth: 100,
      filter: true
    }
  }
  constructor(private formBuilder: FormBuilder, private kpiMaster: KpimasterService,
    private toaster: ToastrService,
    private usermanagementService: UserManagementService, private productivityservice: ProductivityService,
    private spinner: NgxSpinnerService, private translater: TranslaterService,
    private translate: TranslateService, public router: Router,  private dialog: MatDialog) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
    this.columnDefs = [
      { headerName: 'Sr.No', field: 'Sr.No', width: 150,maxWidth: 150 , valueGetter: "node.rowIndex + 1", cellRenderer: 'agGroupCellRenderer', headerValueGetter: this.localizeHeader.bind(this) },
      {
        headerName: 'Name',
        field: 'Name',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Plant',
        field: 'PT_Desc',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Line',
        field: 'PL_Desc',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
    
    ];
  }

  ngOnInit(): void {
    this.initForm();
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.datasource();
  }
  initForm() {
    this.AdminDashboardForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required]
    });
  }

  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.kpiMaster.GetMenuAccess(key).subscribe(
      (data: any) => {
        // this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  datasource(): void {
    const key = {
      UserId: 206, //later it will be change this is only for testing
    };
    const id = {
      value: 0,
    };
    this.productivityservice.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.lstEG;
        if (this.GroupList.length > 0) {
          id.value = data.lstEG[0].EG_Id;
          this.AdminDashboardForm.get('UserGroup1')?.setValue(data.lstEG[0].EG_Id);
          this.filteredGroups = this.GroupList.slice();
          this.getPlants(id);
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }
  getPlants(event: any): void {
    const key = {
      EG_ID: this.AdminDashboardForm.value.UserGroup1,
      userId: 206,
    };
    this.productivityservice.getPlantsData(key).subscribe(
      (data: any) => {
        this.PlantList1 = data.lstPlant;
        if (this.PlantList1.length > 0) {
          const id = data.lstPlant[0].PT_Id;
          this.AdminDashboardForm.get('UserPlant1')?.setValue(id);
          this.filteredPlants = this.PlantList1.slice();
          this.getDashBoardData();
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        //this.gridApi.refreshHeader();
      }
    });
  }
  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }
  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }
  onChangePlant(data: any): void {
    this.getDashBoardData();
  }
  onChangeGroup(data: any): void {
    this.getPlants(data);
    this.AdminDashboardForm.get('UserPlant1')?.setValue(data.lstEG[0].EG_Id);
  }

  getDashBoardData(): void {
    const key = {
      EGID: this.AdminDashboardForm.value.UserGroup1,
      PTID: this.AdminDashboardForm.value.UserPlant1 === '' || this.AdminDashboardForm.value.UserPlant1 === undefined ? 0 :this.AdminDashboardForm.value.UserPlant1,
    };
    this.spinner.show();
    this.productivityservice.GetAdminInfoDashboard(key).subscribe(
      (data: any) => {
        this.DetailsData=data;
        this.DashboardData = data.Table1;
        this.TOTALNOOFMACHINE = data.Table[0]?.TOTALNOOFMACHINE;
        this.CONNECTEDMACHINE = data.Table[0]?.CONNECTEDMACHINE;
        this.NONCONNECTEDMACHINE = data.Table[0]?.NONCONNECTEDMACHINE;
        this.NOOFUSERSINPLANT = data.Table[0]?.NOOFUSERSINPLANT;
        this.NOOFUSERLOGINLAST24 = data.Table[0]?.NOOFUSERLOGINLAST24;
        this.NOOFMODULEINPLANT = data.Table[0]?.NOOFMODULEINPLANT;
        this.NOTOFLINEINPLANT = data.Table[0]?.NOTOFLINEINPLANT;
        this.OTHER = data.Table[0].OTHER;
        this.drawLoginUsersTrends();
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
        this.spinner.hide();
      }
    );
  }

  drawLoginUsersTrends() {
    const data:any[]=[];
    this.DashboardData.forEach(element => {
      data.push([this.getMili(element.LoginTime),element.count]);
    });

    this.options = {
      chart: {
        zoomType: 'x'
    },
    title: {
        text: ''
    },
    xAxis: {
        type: 'datetime'
    },
    yAxis: {
        title: {
            text: 'Users Trends'
        }
    },
    legend: {
        enabled: false
    },
    credits:{
      enabled:false
    },
    plotOptions: {
        area: {
            fillColor: {
                linearGradient: {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 1
                },
                stops: [
                    [0, Highcharts.getOptions().colors[0]],
                    [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                ]
            },
            marker: {
                radius: 2
            },
            lineWidth: 1,
            states: {
                hover: {
                    lineWidth: 1
                }
            },
            threshold: null
        }
    },

    series: [{
        type: 'area',
        name: 'Users',
        data: data
    }]
    };
    let chart = new Chart(this.options);
    this.chartLoginUserstrends = chart;
  }

  getMili(Start_Time: any) {
    var date = moment(Start_Time).format(this.format);
    return new Date(date).getTime();
  }
  closeForm(){

  }
  // Cards details code
  showDetails(type:string): void {
    this.type=type;
    this.dialog.open(this.displayDetailsModal, {
      width: '70vw !important',
      height: '70vh',
      minWidth: '70vw',
    });
    if(type === 'line'){
      this.rowData=this.DetailsData.Table2;
    }else if(type === 'totalMachine'){
      this.rowData=this.DetailsData.Table3;
    }else if(type === 'connectedMachine'){
      this.rowData=this.DetailsData.Table4;
    }else if(type === 'nonConnectedMachine'){
      this.rowData=this.DetailsData.Table5;
    }else if(type === 'noofmodule'){
      this.rowData=this.DetailsData.Table6;
    }else if(type === 'noofusers'){
      this.rowData=this.DetailsData.Table7;
    }else if(type === 'noofuserslast24'){
      this.rowData=this.DetailsData.Table8;
    }else if(type === 'noofcurrentloggedinusers'){
      this.rowData=this.DetailsData.Table9;
    }
   
  }
   //========================================================= AG Grid ====================================================//

   onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if(this.type === 'line'){
      this.gridOptions.columnApi.setColumnVisible('PL_Desc', false);
      this.type=this.getTransalatedValue('detailsofline')
    }else if(this.type === 'totalMachine'){
      this.type=this.getTransalatedValue('detailsofmachine')
    }else if(this.type === 'connectedMachine'){
      this.type=this.getTransalatedValue('detailsofconnectedmachine')
    }else if(this.type === 'nonConnectedMachine'){
      this.type=this.getTransalatedValue('detailsofnonconnectedmachine')
    }else if(this.type === 'noofmodule'){
      this.gridOptions.columnApi.setColumnVisible('PL_Desc', false);
      this.gridOptions.columnApi.setColumnVisible('PT_Desc', false);
      this.type=this.getTransalatedValue('detailsofmodules')
    }else if(this.type === 'noofusers'){
      this.gridOptions.columnApi.setColumnVisible('PL_Desc', false);
      this.type=this.getTransalatedValue('detailsofusers')
    }else if(this.type === 'noofuserslast24'){
      this.gridOptions.columnApi.setColumnVisible('PL_Desc', false);
      this.type=this.getTransalatedValue('detailsof24/husers')
    }else if(this.type === 'noofcurrentloggedinusers'){
      this.gridOptions.columnApi.setColumnVisible('PL_Desc', false);
      this.type=this.getTransalatedValue('detailsofcurrentloggedinusers')
    }
  }
  excelExport() {
    this.gridApi.exportDataAsExcel();
  }
  csvExport() {
    this.gridApi.exportDataAsCsv();
  }
}


